<template>
    <div>
        <vue-countdown
            v-slot="{ seconds }"
            class="opacity-0 h-0"
            :time="time"
            @end="onFinish"
            @progress="onProgress"
        >
            <span class="countdown font-mono text-sm">
                {{ seconds }}
            </span>
        </vue-countdown>
        <PopupBase v-model:visiblePopup="visiblePopup">
            <template #title>
                提醒您
            </template>
            <template #content>
                <span>為確保交易安全，系統將於</span>
                <span class="countdown font-mono text-2xl">
                    {{ now }}
                </span>
                <span>秒後登出，請留意時間。</span>
            </template>
            <template #action>
                <button
                    class="btn btn-accent rounded-full"
                    @click="popupCancel"
                >
                    離開
                </button>
                <button
                    class="btn gradient-primary rounded-full"
                    @click="popupConfirm"
                >
                    繼續使用
                </button>
            </template>
        </PopupBase>
    </div>
</template>
<script>
import { ref, watch, nextTick, onMounted, onBeforeUnmount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import PopupBase from '@/components/dialogs/Popup.vue';

const COUNTDOWN_TIME = 10 * 60 * 1000;
export default {
    components: {
        PopupBase
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const visiblePopup = ref(false);
        const now = ref(null);
        const time = ref(COUNTDOWN_TIME);
        const closePopup = () => {
            visiblePopup.value = false;
        };
        const goFubonOfficial = () => {
            store.dispatch('permissions/goFubonOfficial');
        };
        const popupCancel = () => {
            time.value = 0;
            closePopup();
            goFubonOfficial();
        };

        const popupConfirm = () => {
            time.value = COUNTDOWN_TIME;
            closePopup();
        };

        // 倒數完成直接到個流程的登入頁面
        const onFinish = () => {
            route.meta.backPage && router.push({ name: route.meta.backPage });
        };

        const onProgress = (currentTime) => {
            const { days, hours, minutes, seconds } = currentTime;
            const nowTime = `${days}:${hours}:${minutes}:${seconds}`;
            now.value = seconds;
            if (nowTime === '0:0:0:59') {
                visiblePopup.value = true;
            } else if (nowTime === '0:0:0:1') {
                setTimeout(() => {
                    goFubonOfficial();
                }, 1000);
            }
        };
        // 設定時間為其他時間（需與原時間不同才能觸發重新計時原來的時間）
        let setTime = null;
        onMounted(() => {
            setTime =
                setInterval(() => {
                    time.value = time.value >= 1000 ? time.value - 1000 : 0;
                }, 1000);
        });
        onBeforeUnmount(() => {
            clearInterval(setTime);
        });
        watch(() => route.path, (nV, oV) => {
            nextTick(() => {
                time.value = COUNTDOWN_TIME;
            });
        }, { immediate: true });

        return {
            time,
            visiblePopup,
            onFinish,
            popupCancel,
            popupConfirm,
            onProgress,
            now
        };
    },
};
</script>
<style lang="scss" scoped>
.modal {
    z-index: 9999;
}
</style>
